import { Theme } from "@tvg/design-system";
import styled, { css } from "styled-components";

export const MyBetsContainer = styled.div<{
  theme: Theme;
}>`
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white[900]};
      border: 1px solid ${theme.colors.blue["100"]};
      border-radius: ${theme.radii.s};
    `}
`;

export const StyledHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `14px ${theme.space["space-4"]}`};
  background-color: ${({ theme }) => theme.colors.white[900]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.blue["100"]};
  border-top-left-radius: ${({ theme }) => theme.radii.s};
  border-top-right-radius: ${({ theme }) => theme.radii.s};
`;

export const BetsSummary = styled.div`
  display: flex;
  align-items: center;
`;

const handleScrollForLessThan3Runners = (
  areWagersNumberGreaterThan3: boolean | undefined
) =>
  areWagersNumberGreaterThan3 &&
  css`
    height: 300px;
    overflow-y: auto;
  `;

const handleScrollForMoreThan2Runners = (
  isAuxiliaryHigherThanPrimary: boolean | number | undefined,
  myBetsMaxHeight: number | undefined
) =>
  isAuxiliaryHigherThanPrimary &&
  css`
    height: ${myBetsMaxHeight}px;
    overflow-y: auto;
  `;

export const BetInfoContainer = styled.div<{
  isAuxiliaryHigherThanPrimary?: boolean | number;
  myBetsMaxHeight?: number;
  areRunnersNumGreaterThan2?: boolean;
  areWagersNumberGreaterThan3?: boolean;
}>`
  ${({
    isAuxiliaryHigherThanPrimary,
    myBetsMaxHeight,
    areRunnersNumGreaterThan2,
    areWagersNumberGreaterThan3
  }) =>
    areRunnersNumGreaterThan2
      ? handleScrollForMoreThan2Runners(
          isAuxiliaryHigherThanPrimary,
          myBetsMaxHeight
        )
      : handleScrollForLessThan3Runners(areWagersNumberGreaterThan3)}
`;
